module.exports = __webpack_public_path__ + "static/media/meetingCopy.b5f6f056.svg";